import http from './http-common'
import { CleoConversation, CleoConversationListResponse, FeedbackRating } from '../models/cleo.model'

const BASE_URI = '/ai-assistant/conversations'
const MESSAGES_URI = '/ai-assistant/messages'

export const createConversation = () =>
    http.post<CleoConversation>(BASE_URI, { channel: 'web' })

export const listConversations = (page: number = 1, size: number = 15) =>
    http.get<CleoConversationListResponse>(`${BASE_URI}?page=${page}&size=${size}`)

export const getConversation = (id: number) =>
    http.get<CleoConversation>(`${BASE_URI}/${id}`)

export const deleteConversation = (id: number) =>
    http.delete(`${BASE_URI}/${id}`)

export const sendMessageFeedback = (messageId: number, rating: FeedbackRating, comment?: string) =>
    http.post(`${MESSAGES_URI}/${messageId}/feedback`, { rating, comment })

export const sendMessageSSE = (conversationId: number, content: string, signal?: AbortSignal) => {
    const { REACT_APP_URL_API } = process.env
    const token = localStorage.getItem('token')

    return fetch(`${REACT_APP_URL_API}${BASE_URI}/${conversationId}/messages`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ content }),
        signal,
    })
}
